import { getPlayer, getTeam } from "../../utils.js";
import GameFactEventDto from "../GameFactEventDto.js";

export class DropDto extends GameFactEventDto {

    constructor(event){
        super(event);
        this.tab = event.tab ??"DROP"
        this.detail = {
            ...this.detail,
            title : event.detail?.title || "DROP",
            droper: event.detail?.droper,
            dropSucced: event.detail?.dropSucced ?? true,
          };
    }

    get droper() {
        return this.detail.droper;
    }
    set droper(value) {
        this.detail.droper = value;
    }

    get dropSucced() {
        return this.detail.dropSucced;
    }

    set dropSucced(value) {
        this.detail.dropSucced = value;
    }

    initTimerPeriod(match){
        super.initTimerPeriod(match)
    }

    updateDetail(key, value, match) {
        super.updateDetail(key, value)
        
        // On peut modifier le text et le title
        if(this.isAutomaticCommentary && ["isAutomaticCommentary", "team", "droper", "dropSucced"].includes(key)){
            let commentaire = "Drop"

            const droperPlayer = getPlayer(this.droper, match)
            const team = getTeam(this.team, match)

            if(this.droper){
                if(droperPlayer){
                    commentaire += ' de '+ droperPlayer.lastname
                }
            }else if(team){
                commentaire += ' pour '+ team.name
            }

            commentaire += "! "

            if(!this.dropSucced)
                 commentaire += "Malheureusement le drop est manqué."

            this.text = commentaire
        }
    }
}